<template>
  <div class="OrgProfile">
    <ShortNavbar class="Navbar" />

    <div class="PageContent container">
      <RouterPanel />
      <router-view />
    </div>

    <GeneralFooter class="Footer" />
  </div>
</template>

<script>
import ShortNavbar from "@/components/ShortNavbar";
import { mapGetters } from "vuex";
import GeneralFooter from "@/components/Footer";
import RouterPanel from "@/components/Admin/RouterPanel";

export default {
  components: { 
    ShortNavbar, 
    GeneralFooter,
    RouterPanel
  },
  computed: {
    ...mapGetters({
      user: "auth/isLoggedIn",
    }),
  },
};
</script>

<style scoped>
.OrgProfile {
  position: relative;
  display: flex;

  width: 100%;
  height: auto;
  min-height: 100svh;

  flex-direction: column;
  justify-content: flex-start;

  background-color: white;
}
.Footer {
  margin-top: auto;
}
.Navbar {
  position: absolute;
  padding: 15px 0%;
  top: 0;
}
.container {
  width: 100%;
  max-width: 1168px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 20px;
  padding-right: 20px;
  margin-top: 80px;
  margin-bottom: 165px;
  padding-top: 40px;
}
.PageContent {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: column;
  justify-content: flex-start;

  font-family: "Involve";
}
</style>
